import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Modal } from 'react-bootstrap';
import styles from '../Actions.scss';
import ReservationConfirmation from './ReservationConfirmation';
import ReservationForm from './ReservationForm';
import useEventTrigger from '../../../../../../../modules/react/hooks/useEventTrigger';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  receipt: PropTypes.shape({
    userErrors: PropTypes.arrayOf(
      PropTypes.shape({
        message: PropTypes.string,
      }),
    ),
  }),
  enableMoveInNow: PropTypes.bool.isRequired,
};

const defaultProps = {
  receipt: undefined,
};

const ReservationModal = (props) => {
  let content = null;
  const { addEvent } = useEventTrigger();
  const {
    onSubmit,
    onSubmitSuccess,
    onClose,
    receipt,
    tier,
    price,
    enableMoveInNow,
  } = props;

  if (receipt && !receipt.userErrors) {
    content = (
      <ReservationConfirmation
        {...props}
        onClose={onClose}
        enableMoveInNow={enableMoveInNow}
        price={tier?.price || price}
      />
    );
  } else {
    content = (
      <ReservationForm
        {...props}
        onSubmit={onSubmit}
        onSubmitSuccess={onSubmitSuccess}
        onClose={onClose}
        userErrors={receipt?.userErrors}
        addEvent={addEvent}
      />
    );
  }

  return (
    <Modal
      show
      onHide={onClose}
      className={styles.reserveModal}
      size="md"
      animation
    >
      {content}
    </Modal>
  );
};

ReservationModal.propTypes = propTypes;
ReservationModal.defaultProps = defaultProps;

ReservationModal.fragments = {
  facility: gql`
    fragment ReservationModalFacility on Facility {
      ...ReservationConfirmationFacility
    }

    ${ReservationConfirmation.fragments.facility}
  `,
  reservation: gql`
    fragment ReservationModalReservation on Reservation {
      ...ReservationConfirmationReservation
    }

    ${ReservationConfirmation.fragments.reservation}
  `,
  unitGroup: gql`
    fragment ReservationModalUnitGroup on UnitGroup {
      ...ReservationConfirmationUnitGroup
    }

    ${ReservationConfirmation.fragments.unitGroup}
  `,
};

export default ReservationModal;
